// Shared by ProjectsModal (table + Excel report) and ProjectDetailModal.

// Hasta durumları - PatientsModal ile aynı sözlük. Etiketler Excel raporunda
// kullanılır (rapor Türkçe kalır); ekranda i18n `projectDetail.patientStatus`.
export const PATIENT_STATUSES = {
  planned: { label: 'Planlanan', color: '#f59e0b' },
  screened: { label: 'Screen Edilen', color: '#3b82f6' },
  screenFail: { label: 'Screen Fail', color: '#ef4444' },
  enrolled: { label: 'Dahil Edilen', color: '#8b5cf6' },
  active: { label: 'Aktif', color: '#10b981' },
  onMedication: { label: 'İlaç Alan', color: '#06b6d4' },
  completed: { label: 'Tamamlanan', color: '#6b7280' },
  withdrawn: { label: 'Çekilen', color: '#dc2626' },
};

// Same colours as classes, for Tailwind markup (inline colours lose to the
// dark-mode shield on legacy pages).
export const PATIENT_STATUS_DOTS = {
  planned: 'tw-bg-amber-500',
  screened: 'tw-bg-blue-500',
  screenFail: 'tw-bg-red-500',
  enrolled: 'tw-bg-violet-500',
  active: 'tw-bg-emerald-500',
  onMedication: 'tw-bg-cyan-500',
  completed: 'tw-bg-slate-500',
  withdrawn: 'tw-bg-red-600',
};

export const formatDate = (value, locale = 'tr-TR') => {
  if (!value) return '-';
  if (value.seconds) return new Date(value.seconds * 1000).toLocaleDateString(locale);
  if (typeof value.toDate === 'function') return value.toDate().toLocaleDateString(locale);
  const date = new Date(value);
  return isNaN(date.getTime()) ? String(value) : date.toLocaleDateString(locale);
};

// Bir projeye ait hasta özetini hesaplar (Excel çıktısında da kullanılıyor)
export const buildPatientSummary = (patients) => {
  const byStatus = {};
  Object.keys(PATIENT_STATUSES).forEach((key) => {
    byStatus[key] = 0;
  });
  let homeVisit = 0;
  patients.forEach((patient) => {
    if (patient.status && byStatus[patient.status] !== undefined) {
      byStatus[patient.status] += 1;
    }
    if (patient.hasHomeVisit) homeVisit += 1;
  });
  return { total: patients.length, byStatus, homeVisit };
};

/** "FTE: 0.7", "Saatlik: 250 TRY" ... */
export const formatRate = (rate, hourlyLabel = 'Saatlik') => {
  if (!rate) return '-';
  const type = rate.type?.toUpperCase() === 'FTE' ? 'FTE' : hourlyLabel;
  const amount = rate.value ?? rate.price;
  if (amount === undefined || amount === null || amount === '') return type;
  return `${type}: ${amount}${rate.currency ? ` ${rate.currency}` : ''}`;
};
